import { render } from "./AssetsFiles.vue?vue&type=template&id=5d8f3ce7&ts=true"
import script from "./AssetsFiles.vue?vue&type=script&lang=ts"
export * from "./AssetsFiles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__